import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "11016141-9bcf-4a03-96c8-db469b472055",
    content:
      "A null hypothesis is created with the aim of rejecting it<br>and therefore accepting the alternative hypothesis.",
    options: {},
  },
  {
    id: "3badb187-6010-481f-86ff-1aa73de56d9a",
    content: "If a null hypothesis can not be rejected, it means the null hypothesis is true.",
    options: {},
  },
  {
    id: "59412dbe-1523-4024-8f71-d86f511190fb",
    content:
      "A comparison is statistically significant as long as the p-value<br>is smaller or equal to the significance level (usually 5%).",
    options: {},
  },
];

export const task: Task = {
  id: "ed76879d-e063-43c1-9637-db9b5e322ec6",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["11016141-9bcf-4a03-96c8-db469b472055", "59412dbe-1523-4024-8f71-d86f511190fb"],
};
